import React from 'react';
import {Typography, Switch} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  switchContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 4,
    padding: '6px 14px',

    height: 38, // Match PeriodPicker button height
    backgroundColor: theme.palette.graphColors.themeDarkGray,
  },
  switchText: {
    marginLeft: 4,
    marginRight: 4,
    fontSize: 14,
  },
}));

const ModeSwitch = ({intervalsMode, onModeChange, removeMargin}) => {
  const classes = useStyles();

  return (
    <div className={classes.switchContainer} style={{marginLeft: removeMargin ? 0 : 16}}>
      <Typography display={'inline'} variant={'body'} className={classes.switchText}>
        Deciles
      </Typography>
      <Switch
        color={'primary'}
        // size="small"
        checked={intervalsMode === 1}
        onChange={() => {
          onModeChange(intervalsMode === 0 ? 1 : 0);
        }}
      />
      <Typography display={'inline'} variant={'body'} className={classes.switchText}>
        Fixed intervals
      </Typography>
    </div>
  );
};

export default ModeSwitch;
